import { Link } from 'react-router-dom';
import Hero from './../Hero/Hero';
import { Learn } from './../Learn/Learn';

export const Home = () => {
	return (
		<>
			<Link className='absolute top-0 right-1/2 translate-x-1/2 text-center text-5xl w-96 my-10 font-bold'>
				سورة x صورة
			</Link>
			<Hero />
			<Learn />
			<div className=' w-full text-center py-5 '>
				<a
					href='https://www.developedbyabdu.com'
					target='_blank'
					className=' text-xl font-light transition-all duration-300  leading-6 text-p-dark opacity-80 hover:opacity-100'
				>
					developedByAbdu.com
				</a>
			</div>
		</>
	);
};
